export const CREATE_ACCOUNT_MODAL_STATE_CHANGED = "create_Account_modal_state_changed";
export const ADD_ADDRESS_MODAL_STATE_CHANGED = "add_address_modal_state_changed";
export const ADDRESS_MODAL_DATA_SET = "address_modal_data_set";
export const ELIGIBILITY_MODAL_INITIALIZED = "eligibility_modal_initialized";
export const ELIGIBILITY_MODAL_STATE_CHANGED = "eligibility_modal_state_changed";
export const ALERT_MODAL_STATE_CHANGED = "alert_modal_state_changed";
export const ALERT_MODAL_DATA_SET = "alert_modal_data_set";
export const WIZARD_IN_PROGRESS_MODAL_STATE_CHANGED = "wizard_in_progress_modal_state_changed";
export const WIZARD_IN_PROGRESS_MODAL_DATA_SET = "wizard_in_progress_modal_data_set";
export const LEASE_MODAL_STATE_CHANGED = "lease_modal_state_changed";
export const PROCESS_LEASE_MODAL_STATE_CHANGED = "process_lease_modal_state_changed";
export const PROCESS_LEASE_MODAL_DATA_SET = "process_lease_modal_data_set";
export const ALREADY_APPROVED_MODAL_STATE_CHANGED = "already_approved_modal_state_changed";